"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Iterator_1 = __importDefault(require("./Iterator"));

var Op;

(function (Op) {
  function iterator(ops) {
    return new Iterator_1["default"](ops);
  }

  Op.iterator = iterator;

  function length(op) {
    if (typeof op["delete"] === 'number') {
      return op["delete"];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }

  Op.length = length;
})(Op || (Op = {}));

exports["default"] = Op;